import { ReactComponent as CurrentLocation } from '@at.govt.nz/vector/lib/img/icon-current-location.svg';
import { ReactComponent as History } from '@at.govt.nz/vector/lib/img/icon-history.svg';
import { ReactComponent as Pin } from '@at.govt.nz/vector/lib/img/icon-location.svg';
import { ReactComponent as Poi } from '@at.govt.nz/vector/lib/img/icon-building.svg';
import { ReactComponent as PoiAirplane } from '@at.govt.nz/vector/lib/img/icon-airplane.svg';
import { ReactComponent as PoiBank } from '@at.govt.nz/vector/lib/img/icon-dollar-sign.svg';
import { ReactComponent as PoiBar } from '@at.govt.nz/vector/lib/img/icon-bar.svg';
import { ReactComponent as PoiBeach } from '@at.govt.nz/vector/lib/img/icon-beach.svg';
import { ReactComponent as PoiBridge } from '@at.govt.nz/vector/lib/img/icon-bridge.svg';
import { ReactComponent as PoiCafe } from '@at.govt.nz/vector/lib/img/icon-cafe.svg';
import { ReactComponent as PoiEducation } from '@at.govt.nz/vector/lib/img/icon-book.svg';
import { ReactComponent as PoiEntertainment } from '@at.govt.nz/vector/lib/img/icon-ticket.svg';
import { ReactComponent as PoiGroceries } from '@at.govt.nz/vector/lib/img/icon-cart.svg';
import { ReactComponent as PoiHotel } from '@at.govt.nz/vector/lib/img/icon-hotel.svg';
import { ReactComponent as PoiLibrary } from '@at.govt.nz/vector/lib/img/icon-library.svg';
import { ReactComponent as PoiMarina } from '@at.govt.nz/vector/lib/img/icon-marina.svg';
import { ReactComponent as PoiMedical } from '@at.govt.nz/vector/lib/img/icon-medical.svg';
import { ReactComponent as PoiOutdoors } from '@at.govt.nz/vector/lib/img/icon-park.svg';
import { ReactComponent as PoiParking } from '@at.govt.nz/vector/lib/img/icon-parking-in-a-circle-dark.svg';
import { ReactComponent as PoiPetrol } from '@at.govt.nz/vector/lib/img/icon-fuel.svg';
import { ReactComponent as PoiPool } from '@at.govt.nz/vector/lib/img/icon-pool.svg';
import { ReactComponent as PoiRestaurant } from '@at.govt.nz/vector/lib/img/icon-spoon-and-fork.svg';
import { ReactComponent as PoiRetail } from '@at.govt.nz/vector/lib/img/icon-shopping-bag.svg';
import { ReactComponent as PoiSports } from '@at.govt.nz/vector/lib/img/icon-sports.svg';
import { ReactComponent as PoiSportsGolf } from '@at.govt.nz/vector/lib/img/icon-sports-golf.svg';
import { ReactComponent as PoiSportsTennis } from '@at.govt.nz/vector/lib/img/icon-tennis.svg';
import { ReactComponent as PoiStadium } from '@at.govt.nz/vector/lib/img/icon-stadium.svg';
import { ReactComponent as PromotedDestination } from '@at.govt.nz/vector/lib/img/icon-calendar.svg';
import { ReactComponent as PublicTransport } from '@at.govt.nz/vector/lib/img/icon-bus.svg';
import { ReactComponent as Train } from '@at.govt.nz/vector/lib/img/icon-train.svg';
import { ReactComponent as Ferry } from '@at.govt.nz/vector/lib/img/icon-ferry.svg';

export const ADDRESS_CATEGORIES = {
  ADDRESS: 'ADDRESS',
  BUSSTOP: 'BUSSTOP',
  FERRYTERMINAL: 'FERRYTERMINAL',
  GPS: 'GPS',
  GTFS: 'GTFS',
  MAPSTOP: 'MAPSTOP',
  POI: 'POI',
  SAVED: 'SAVED',
  TRAINSTATION: 'TRAINSTATION',
};

export const GTFS_STOP_CATEGORIES = new Set([
  ADDRESS_CATEGORIES.BUSSTOP,
  ADDRESS_CATEGORIES.TRAINSTATION,
  ADDRESS_CATEGORIES.FERRYTERMINAL,
]);

export const POI_CATEGORY_ICON = {
  AIRPORT: 'PoiAirplane',
  BANK: 'PoiBank',
  BAR: 'PoiBar',
  BEACH: 'PoiBeach',
  BRIDGE: 'PoiBridge',
  CAFE: 'PoiCafe',
  EDUCATION: 'PoiEducation',
  ENTERTAINMENT: 'PoiEntertainment',
  FERRY_TERMINAL: 'Ferry',
  GROCERIES: 'PoiGroceries',
  HOTEL: 'PoiHotel',
  LIBRARY: 'PoiLibrary',
  MARINA: 'PoiMarina',
  MEDICAL: 'PoiMedical',
  OUTDOORS: 'PoiOutdoors',
  OTHER: 'Poi',
  PARKING: 'PoiParking',
  PETROL: 'PoiPetrol',
  POOL: 'PoiPool',
  PUBLIC_TRANSPORT: 'PublicTransport',
  RESTAURANT: 'PoiRestaurant',
  RETAIL: 'PoiRetail',
  SPORTS: 'PoiSports',
  GOLF: 'PoiSportsGolf',
  STADIUM: 'PoiStadium',
  TENNIS: 'PoiSportsTennis',
  TRAIN_STATION: 'Train',
};

export const UNTYPED_CATEGORY_ICON = {
  [ADDRESS_CATEGORIES.ADDRESS]: 'Pin',
  [ADDRESS_CATEGORIES.BUSSTOP]: 'PublicTransport',
  [ADDRESS_CATEGORIES.TRAINSTATION]: 'Train',
  [ADDRESS_CATEGORIES.FERRYTERMINAL]: 'Ferry',
  [ADDRESS_CATEGORIES.GPS]: 'CurrentLocation',
  [ADDRESS_CATEGORIES.MAPSTOP]: 'Pin',
  [ADDRESS_CATEGORIES.POI]: 'PromotedDestination',
  [ADDRESS_CATEGORIES.SAVED]: 'History',
};

export const SEARCH_CATEGORY_SVG_ICON = {
  CurrentLocation,
  History,
  Pin,
  Poi,
  PoiAirplane,
  PoiBank,
  PoiBar,
  PoiBeach,
  PoiBridge,
  PoiCafe,
  PoiEducation,
  PoiEntertainment,
  PoiGroceries,
  PoiHotel,
  PoiLibrary,
  PoiMarina,
  PoiMedical,
  PoiOutdoors,
  PoiParking,
  PoiPetrol,
  PoiPool,
  PoiRestaurant,
  PoiRetail,
  PoiSports,
  PoiSportsGolf,
  PoiSportsTennis,
  PoiStadium,
  PromotedDestination,
  PublicTransport,
  Train,
  Ferry,
};
